import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import TableTrafficFines from "./components/table-trafficfines/TableTrafficFines";

export function TrafficFinesReportsRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableTrafficFines />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
